// Module
var code = "<div> <div class=\"md:-mt-16\" view=\"Repeat\" data-items=\"[[content_elements]]\" data-as=\"element\"> <div class=\"md:first:mt-16\" view=\"[[element]]\" data=\"[[ element ]]\"></div> </div> </div> ";
// Exports
export default code;